import styled from "styled-components";
import { SIDEBAR_WIDTH } from "./Layouts/PageLayout/PageLayoutStyles";

export const NavBase = styled.div<{ removeSidebarWidth?: boolean }>`
  align-items: center;
  background-color: white;
  display: flex;
  justify-content: space-between;
  padding: 10px 0px 10px 30px;
  position: fixed;
  top: 0;
  width: ${({ removeSidebarWidth }) => (removeSidebarWidth ? `calc(100vw - ${SIDEBAR_WIDTH}px)` : "100%")};
  z-index: 3;

  > div:only-child {
    margin-left: auto;
    
  }
`;

export const NavBaseOffset = styled.div`
  width: 100%;
  height: 70px;
`;
